import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import HomePage from "./components/HomePage";
import NewsPage from "./components/NewsPage";
import Footer from "./components/Footer";
import SquarespaceTest from "./components/SquarespaceTest";
import { useSquarespaceContent } from "./hooks/useSquarespaceContent";
import { mockData } from "./utils/mockData";
import "./App.css";

// Wrapper component to handle location-based logic
const AppContent = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const { content, loading } = useSquarespaceContent();

  // Use Squarespace content if available, otherwise fall back to mock data
  const footerData = content?.footer || mockData.footer;

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/test" element={<SquarespaceTest />} />
      </Routes>
      <Footer data={footerData} isHome={isHome} />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;